"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var use_modal_toggle_state_hook_1 = __importDefault(require("../../hooks/use-modal-toggle-state.hook"));

var scenario_node_view_component_1 = __importDefault(require("../scenario-node-view/scenario-node-view.component"));

var core_1 = require("@material-ui/core");

var scenario_node_gallery_card_style_1 = require("./scenario-node-gallery-card.style");

var Edit_1 = __importDefault(require("@material-ui/icons/Edit"));

var AspectRatio_1 = __importDefault(require("@material-ui/icons/AspectRatio"));

var custom_modal_component_1 = __importDefault(require("../../common-components/custom-modal/custom-modal.component"));

var EditButton = function EditButton(_ref) {
  var onClick = _ref.onClick;
  return react_1.default.createElement(core_1.Button, {
    onClick: onClick
  }, react_1.default.createElement(Edit_1.default, null), react_1.default.createElement(scenario_node_gallery_card_style_1.StyledEditButtonTextSpan, null, "\u7DE8\u96C6"));
};

var DetailButton = function DetailButton(_ref2) {
  var onClick = _ref2.onClick;
  return react_1.default.createElement(core_1.Button, {
    onClick: onClick
  }, react_1.default.createElement(AspectRatio_1.default, null), react_1.default.createElement(scenario_node_gallery_card_style_1.StyledDetailButtonTextSpan, null, "\u62E1\u5927"));
};

var ScenarioNodeGalleryCard = function ScenarioNodeGalleryCard(_ref3) {
  var node = _ref3.node,
      _ref3$scale = _ref3.scale,
      scale = _ref3$scale === void 0 ? 0.5 : _ref3$scale,
      onCardClick = _ref3.onCardClick,
      enableDetailView = _ref3.enableDetailView,
      onEditClick = _ref3.onEditClick;

  var _use_modal_toggle_sta = use_modal_toggle_state_hook_1.default(),
      modalProps = _use_modal_toggle_sta.modalProps,
      handleOpen = _use_modal_toggle_sta.handleOpen;

  return react_1.default.createElement(scenario_node_gallery_card_style_1.StyledScenarioGalleryCardWrapperDiv, null, react_1.default.createElement(scenario_node_gallery_card_style_1.StyledGalleryCard, {
    onClick: onCardClick
  }, react_1.default.createElement(scenario_node_gallery_card_style_1.StyledScenarioNodeGalleryContentDiv, null, react_1.default.createElement(scenario_node_gallery_card_style_1.StyledScenarioNodeWrapperDiv, null, react_1.default.createElement(scenario_node_view_component_1.default, {
    node: node,
    scale: scale
  })))), (!!enableDetailView || !!onEditClick) && react_1.default.createElement(scenario_node_gallery_card_style_1.StyledEditButtonBoxDiv, null, !!enableDetailView && react_1.default.createElement(DetailButton, {
    onClick: handleOpen
  }), !!onEditClick && react_1.default.createElement(EditButton, {
    onClick: onEditClick
  })), enableDetailView && react_1.default.createElement(custom_modal_component_1.default, Object.assign({}, modalProps), react_1.default.createElement(scenario_node_gallery_card_style_1.StyledGalleryCard, null, react_1.default.createElement(scenario_node_gallery_card_style_1.StyledModalScenarioNodeWrapperDiv, null, react_1.default.createElement(scenario_node_view_component_1.default, {
    node: node
  })))));
};

exports.default = ScenarioNodeGalleryCard;